<template>
  <div class="sessions-section">
    <h2 class="section-title">
      <i class="fas fa-calendar-alt"></i> Sessions 
      <span class="count-badge">{{ sessions?.length || 0 }}</span>
    </h2>
    <div class="section-card">
      <div v-if="sessions?.length" class="sessions-list">
        <div v-for="session in sessions" :key="session.id" class="session-card">
          <div class="session-header">
            <span class="session-status" :class="session.status.toLowerCase()">{{ session.status }}</span>
            <span class="session-price">${{ session.price }}</span>
          </div>
          <div class="session-details">
            <div class="session-meta">
              <span><i class="fas fa-clock"></i> {{ session.session_duration }} mins</span>
              <span><i class="fas fa-video"></i> {{ session.session_type }}</span>
            </div>
            <p class="session-notes" v-if="session.note">{{ session.note }}</p>
            <div class="session-dates" v-if="session.start_time">
              <i class="fas fa-calendar"></i> {{ new Date(session.start_time).toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
      <p v-else class="no-data-message">No sessions scheduled.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructorSessions',
  props: {
    sessions: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.sessions-section {
  margin-bottom: 2rem;
}

.section-title {
  margin: 0 0 1.25rem;
  color: #1e293b;
  font-size: 1.375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title i {
  color: #3b82f6;
  font-size: 1.25rem;
}

.count-badge {
  background: #e2e8f0;
  color: #475569;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  margin-left: 0.5rem;
}

.section-card {
  background: white;
  padding: 1.5rem;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.5rem;
}

.session-card {
  background: #f8fafc;
  padding: 1.25rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
}

.session-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.session-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.session-status {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-weight: 500;
}

.session-status.active {
  background: #dcfce7;
  color: #16a34a;
}

.session-status.pending {
  background: #fef3c7;
  color: #d97706;
}

.session-status.canceled {
  background: #fee2e2;
  color: #ef4444;
}

.session-status.completed {
  background: #e0f2fe;
  color: #0284c7;
}

.session-price {
  font-weight: 600;
  color: #1e293b;
}

.session-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.session-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  color: #64748b;
  font-size: 0.875rem;
}

.session-meta span {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.session-notes {
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.6;
}

.session-dates {
  color: #64748b;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.no-data-message {
  color: #94a3b8;
  text-align: center;
  font-style: italic;
  margin: 1rem 0;
}

@media (max-width: 768px) {
  .session-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .session-status {
    align-self: flex-start;
  }
}
</style> 